import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=00885f8c&scoped=true"
import script from "./recommend.vue?vue&type=script&lang=js"
export * from "./recommend.vue?vue&type=script&lang=js"
import style0 from "./recommend.vue?vue&type=style&index=0&id=00885f8c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00885f8c",
  null
  
)

export default component.exports